// extracted by mini-css-extract-plugin
export var cardLayout = "_7g-1";
export var paginationContainer = "_7g-0";